import { CameraOpener, SDKEnvironmentTypes, SelfieCameraTypes, UnicoCheckBuilder, UnicoConfig, UnicoThemeBuilder } from 'unico-webframe'
import { getBiometryConfig } from '../../common/AssetsHelper'
import { UnicoSDKConfig } from '../../redux/reducers/configurations/biometry.configurations'

class UnicoSDKService {
  camera: Promise<CameraOpener> | undefined
  constructor() {
    const config = getBiometryConfig()

    if (!config) return 

    const unicoConfig = new UnicoConfig()
      .setHostname(config.unico.sdkConfig.hostname)
      .setHostKey(config.unico.sdkConfig.hostKey)

    const unicoCameraBuilder = new UnicoCheckBuilder()

    const unicoTheme = new UnicoThemeBuilder()
      .setColorSilhouetteSuccess('#11b048')
      .setColorSilhouetteError('#D50000')
      .setColorSilhouetteNeutral('#fcfcfc')
      .setBackgroundColor('#dff1f5')
      .setColorText(config.unico.style.primaryColor)
      .setBackgroundColorComponents(config.unico.style.primaryColor)
      .setColorTextComponents('#dff1f5')
      .setBackgroundColorButtons(config.unico.style.primaryColor)
      .setColorTextButtons('#dff1f5')
      .setBackgroundColorBoxMessage('#fff')
      .setColorTextBoxMessage('#000')
      .setHtmlPopupLoading(
        `<div style="position: absolute; top: 45%; right: 50%; transform:
          translate(50%, -50%); z-index: 10; text-align: center; height: 100%;">Carregando...</div>`
      )
      .build()

    const environment = this.shouldSetUATEnvironment(config.unico.sdkConfig)
     ? SDKEnvironmentTypes.UAT
     : SDKEnvironmentTypes.PROD

    unicoCameraBuilder.setEnvironment(environment)
    unicoCameraBuilder.setModelsPath(config.unico.sdkConfig.modelsPath).setResourceDirectory(config.unico.sdkConfig.resourcesPath)
    unicoCameraBuilder.setTheme(unicoTheme)
    const unicoCamera = unicoCameraBuilder.build()

    this.camera = unicoCamera.prepareSelfieCamera(unicoConfig, SelfieCameraTypes.SMART)
  }

  private shouldSetUATEnvironment(unicoConfig: UnicoSDKConfig): boolean {
    return !!unicoConfig.uatEnvironment
  }
}

export default UnicoSDKService
